var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    ref: "googleTranslateElement",
    attrs: {
      "id": "google_translate_element"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }